import { Button } from "@/design-system/components/Button/Button";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import clsx from "clsx";

import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import TeamPage from "./TeamPage";
import ProjectsPage from "./projects";
import useUsers from "./hooks/useUsers";
import FreshpaintUser from "./components/users/FreshpaintUser";
import eventsEmptyStateImage from "./img/events_empty_state.svg";

const useNoEnvironmentsClasses = makeStyles(() => ({
  container: {
    paddingTop: 150 + 64,
    paddingLeft: 0,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  paragraph: {
    width: 500,
    margin: 20,
  },
}));

function NoEnvironmentsBase({ message, buttonText, buttonLink }) {
  const classes = useNoEnvironmentsClasses();

  return (
    <div className={clsx(classes.container)}>
      <img
        className="mb-4"
        alt="No Projects & Environments"
        src={eventsEmptyStateImage}
        height={201}
        width={273}
      />
      <h1 className="mb-4">Found No Projects & Environments</h1>
      <p className={classes.paragraph}>{message}</p>
      {buttonLink && <Button href={buttonLink}>{buttonText}</Button>}
    </div>
  );
}

function AppNoEnvironments() {
  const usersState = useUsers();
  const currentUser = usersState.loading
    ? null
    : new FreshpaintUser(usersState.currentUser);

  let message = "";
  let buttonLink, buttonText;

  if (currentUser) {
    if (currentUser.hasAdminAccess()) {
      message = "You should create some projects & environments.";
      buttonLink = "/settings/projects";
      buttonText = "Visit Projects Page";
    } else {
      message =
        "You should ask your Account Admin to grant you access to some environments";
      buttonLink = "/settings/team";
      buttonText = "Visit Team Page";
    }
  }

  return (
    <div className="Body">
      <Switch>
        <Route
          exact={true}
          path="/"
          render={() => (
            <NoEnvironmentsBase
              message={message}
              buttonLink={buttonLink}
              buttonText={buttonText}
            />
          )}
        />
        <Route path="/settings/team" component={TeamPage} />
        <Route
          path="/settings/projects"
          render={() => {
            if (usersState.loading) {
              return (
                <h3 style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                  Loading
                </h3>
              );
            }
            return <ProjectsPage />;
          }}
        />
        <Route render={() => <Redirect to={{ pathname: "/" }} />} />
      </Switch>
    </div>
  );
}

export default AppNoEnvironments;
